export const vicInstallsData = [
  {
    "name": "ALFREDTON",
    "value": 6,
    "lat": -37.558214,
    "lng": 143.7998153
  },
  {
    "name": "ASHBURTON",
    "value": 16,
    "lat": -37.8673582,
    "lng": 145.0806524
  },
  {
    "name": "Abbotsford",
    "value": 19,
    "lat": -37.8045508,
    "lng": 144.9988542
  },
  {
    "name": "Aberfeldie",
    "value": 13,
    "lat": -37.7596196,
    "lng": 144.8974571
  },
  {
    "name": "Aintree",
    "value": 135,
    "lat": -37.7193933,
    "lng": 144.6694023
  },
  {
    "name": "Airport West",
    "value": 47,
    "lat": -38.0952468,
    "lng": 146.9634381675828
  },
  {
    "name": "Albanvale",
    "value": 5,
    "lat": -37.7460824,
    "lng": 144.7685623
  },
  {
    "name": "Albert Park",
    "value": 424,
    "lat": -37.8452062,
    "lng": 144.957105
  },
  {
    "name": "Albion",
    "value": 5,
    "lat": -37.777227350000004,
    "lng": 144.82439260596044
  },
  {
    "name": "Alphington",
    "value": 7,
    "lat": -37.7783921,
    "lng": 145.0312833
  },
  {
    "name": "Altona",
    "value": 37,
    "lat": -37.867150300000006,
    "lng": 144.82946367934787
  },
  {
    "name": "Altona Meadows",
    "value": 14,
    "lat": -37.8814419,
    "lng": 144.7845482
  },
  {
    "name": "Altona North",
    "value": 47,
    "lat": -37.8671223,
    "lng": 144.8294793
  },
  {
    "name": "Altona Nth",
    "value": 1,
    "lat": -37.867150300000006,
    "lng": 144.82946367934787
  },
  {
    "name": "Anakie",
    "value": 1,
    "lat": -37.9111181,
    "lng": 144.2544828
  },
  {
    "name": "Anglesea",
    "value": 2,
    "lat": -38.4051948,
    "lng": 144.188958
  },
  {
    "name": "Ardeer",
    "value": 7,
    "lat": -37.7758681,
    "lng": 144.8014637
  },
  {
    "name": "Armadale",
    "value": 14,
    "lat": -37.8563442,
    "lng": 145.01932066100542
  },
  {
    "name": "Armstrong Creek",
    "value": 88,
    "lat": -38.2341184,
    "lng": 144.3709512
  },
  {
    "name": "Arthurs Seat",
    "value": 2,
    "lat": -38.35407605,
    "lng": 144.9506147060341
  },
  {
    "name": "Ascot Vale",
    "value": 26,
    "lat": -37.7753252,
    "lng": 144.921825
  },
  {
    "name": "Ashwood",
    "value": 20,
    "lat": -37.866672,
    "lng": 145.1022346
  },
  {
    "name": "Aspendale",
    "value": 8,
    "lat": -38.0272365,
    "lng": 145.1021263
  },
  {
    "name": "Aspendale Gardens",
    "value": 3,
    "lat": -38.0221438,
    "lng": 145.11984
  },
  {
    "name": "Attwood",
    "value": 4,
    "lat": -37.6670148,
    "lng": 144.884862
  },
  {
    "name": "Avalon",
    "value": 10,
    "lat": -38.0415747,
    "lng": 144.47225146948307
  },
  {
    "name": "Avoca",
    "value": 2,
    "lat": -36.3215688,
    "lng": 143.3191753
  },
  {
    "name": "Avondale Heights",
    "value": 25,
    "lat": -37.7614537,
    "lng": 144.862141
  },
  {
    "name": "Avonsleigh",
    "value": 2,
    "lat": -37.9208356,
    "lng": 145.4688212
  },
  {
    "name": "BAXTER",
    "value": 2,
    "lat": -38.1940808,
    "lng": 145.160517
  },
  {
    "name": "BEAUFORT",
    "value": 2,
    "lat": -37.437707,
    "lng": 143.3835896
  },
  {
    "name": "BOX HILL NORTH",
    "value": 27,
    "lat": -37.8056831,
    "lng": 145.1295748
  },
  {
    "name": "BURNSIDE",
    "value": 22,
    "lat": -37.749374,
    "lng": 144.753027
  },
  {
    "name": "BURWOOD EAST",
    "value": 22,
    "lat": -37.8535935,
    "lng": 145.150423
  },
  {
    "name": "Bacchus Marsh",
    "value": 17,
    "lat": -37.6751897,
    "lng": 144.4366202
  },
  {
    "name": "Badger Creek",
    "value": 1,
    "lat": -37.7015267,
    "lng": 145.5329174
  },
  {
    "name": "Balaclava",
    "value": 3,
    "lat": -37.869543,
    "lng": 144.99348708903125
  },
  {
    "name": "Ballan",
    "value": 4,
    "lat": -37.603984499999996,
    "lng": 144.21427345615277
  },
  {
    "name": "Ballarat",
    "value": 5,
    "lat": -37.5623013,
    "lng": 143.8605645
  },
  {
    "name": "Ballarat Central",
    "value": 7,
    "lat": -37.5627279,
    "lng": 143.8501516
  },
  {
    "name": "Ballarat East",
    "value": 4,
    "lat": -37.564603000000005,
    "lng": 143.89704664637077
  },
  {
    "name": "Balliang East",
    "value": 1,
    "lat": -37.7930443,
    "lng": 144.418291
  },
  {
    "name": "Balwyn",
    "value": 22,
    "lat": -37.798089399999995,
    "lng": 145.0754158044889
  },
  {
    "name": "Balwyn North",
    "value": 24,
    "lat": -37.798089399999995,
    "lng": 145.0754158044889
  },
  {
    "name": "Bandiana",
    "value": 4,
    "lat": -36.131111000000004,
    "lng": 146.9372029958601
  },
  {
    "name": "Bangholme",
    "value": 9,
    "lat": -38.0483919,
    "lng": 145.1720859
  },
  {
    "name": "Bannockburn",
    "value": 9,
    "lat": -38.0443362,
    "lng": 144.1738367
  },
  {
    "name": "Barrabool",
    "value": 1,
    "lat": -38.1691773,
    "lng": 144.2262729
  },
  {
    "name": "Barwon Heads",
    "value": 7,
    "lat": -38.2747705,
    "lng": 144.4881352
  },
  {
    "name": "Bayswater",
    "value": 30,
    "lat": -37.841739,
    "lng": 145.2681208
  },
  {
    "name": "Bayswater North",
    "value": 11,
    "lat": -37.8260474,
    "lng": 145.2819271
  },
  {
    "name": "Beaconsfield",
    "value": 11,
    "lat": -38.0510344,
    "lng": 145.36634205777816
  },
  {
    "name": "Beaconsfield Upper",
    "value": 1,
    "lat": -37.998526,
    "lng": 145.4247844
  },
  {
    "name": "Beaumaris",
    "value": 7,
    "lat": -37.9822122,
    "lng": 145.0389098
  },
  {
    "name": "Belgrave",
    "value": 5,
    "lat": -37.9090141,
    "lng": 145.3552538
  },
  {
    "name": "Belgrave Heights",
    "value": 3,
    "lat": -37.9189877,
    "lng": 145.34607918830886
  },
  {
    "name": "Bell Park",
    "value": 1,
    "lat": -38.1077279,
    "lng": 144.338362
  },
  {
    "name": "Bell Post Hill",
    "value": 5,
    "lat": -38.097295,
    "lng": 144.3235644
  },
  {
    "name": "Bellbrae",
    "value": 1,
    "lat": -38.3308213,
    "lng": 144.2620821
  },
  {
    "name": "Bellfield",
    "value": 2,
    "lat": -37.7531065,
    "lng": 145.0384784
  },
  {
    "name": "Belmont",
    "value": 7,
    "lat": -38.1785947,
    "lng": 144.3421337
  },
  {
    "name": "Benalla",
    "value": 1,
    "lat": -36.5517611,
    "lng": 145.9833562
  },
  {
    "name": "Bendigo",
    "value": 9,
    "lat": -36.7590183,
    "lng": 144.2826718
  },
  {
    "name": "Bentleigh",
    "value": 25,
    "lat": -37.9175354,
    "lng": 145.0369346
  },
  {
    "name": "Bentleigh East",
    "value": 45,
    "lat": -37.9220201,
    "lng": 145.0665529
  },
  {
    "name": "Berrys Creek",
    "value": 1,
    "lat": -38.412839500000004,
    "lng": 146.06793432291204
  },
  {
    "name": "Berwick",
    "value": 191,
    "lat": -38.0259389,
    "lng": 145.31175423127402
  },
  {
    "name": "Bet Bet",
    "value": 1,
    "lat": -36.9238563,
    "lng": 143.7572734
  },
  {
    "name": "Beveridge",
    "value": 100,
    "lat": -37.4712651,
    "lng": 144.9745663
  },
  {
    "name": "Birregurra",
    "value": 3,
    "lat": -38.3377863,
    "lng": 143.7843347
  },
  {
    "name": "Bittern",
    "value": 4,
    "lat": -38.3373754,
    "lng": 145.1779381
  },
  {
    "name": "Black Hill",
    "value": 2,
    "lat": -37.5497395,
    "lng": 143.87326329792276
  },
  {
    "name": "Black Rock",
    "value": 7,
    "lat": -37.9706564,
    "lng": 145.0212822
  },
  {
    "name": "Blackburn",
    "value": 32,
    "lat": -37.82013725,
    "lng": 145.1500496182243
  },
  {
    "name": "Blackburn North",
    "value": 30,
    "lat": -37.8053801,
    "lng": 145.154324
  },
  {
    "name": "Blackburn South",
    "value": 21,
    "lat": -37.8388322,
    "lng": 145.1487848
  },
  {
    "name": "Blind Bight",
    "value": 2,
    "lat": -38.2142175,
    "lng": 145.3377629
  },
  {
    "name": "Bonbeach",
    "value": 4,
    "lat": -38.065449,
    "lng": 145.120108
  },
  {
    "name": "Bonnie Brook",
    "value": 30,
    "lat": -37.6947562,
    "lng": 144.6710866
  },
  {
    "name": "Bonshaw",
    "value": 2,
    "lat": -37.602671,
    "lng": 143.8136780563564
  },
  {
    "name": "Boronia",
    "value": 46,
    "lat": -37.860645,
    "lng": 145.2848446
  },
  {
    "name": "Botanic Ridge",
    "value": 25,
    "lat": -38.1413786,
    "lng": 145.2566183
  },
  {
    "name": "Boulevard CLYDE",
    "value": 1,
    "lat": -38.1169117,
    "lng": 145.3457657
  },
  {
    "name": "Box Hill",
    "value": 36,
    "lat": -37.8192487,
    "lng": 145.1221382
  },
  {
    "name": "Box Hill South",
    "value": 10,
    "lat": -37.8366236,
    "lng": 145.1233644
  },
  {
    "name": "Box Hill VIC 3128",
    "value": 1,
    "lat": -37.8215116,
    "lng": 145.1261267
  },
  {
    "name": "Braeside",
    "value": 18,
    "lat": -38.0005245,
    "lng": 145.1229578
  },
  {
    "name": "Braybrook",
    "value": 21,
    "lat": -37.77744905,
    "lng": 144.8486197662329
  },
  {
    "name": "Breakwater",
    "value": 3,
    "lat": -38.1823897,
    "lng": 144.3735473
  },
  {
    "name": "Briar Hill",
    "value": 3,
    "lat": -37.7063703,
    "lng": 145.1216479
  },
  {
    "name": "Brighton",
    "value": 31,
    "lat": -37.9081962,
    "lng": 144.9957991
  },
  {
    "name": "Brighton East",
    "value": 18,
    "lat": -37.9213636,
    "lng": 145.01850046991083
  },
  {
    "name": "Broadford",
    "value": 4,
    "lat": -37.2039288,
    "lng": 145.03921813797695
  },
  {
    "name": "Broadmeadows",
    "value": 46,
    "lat": -37.68305265,
    "lng": 144.91948587060236
  },
  {
    "name": "Brookfield",
    "value": 13,
    "lat": -37.6993389,
    "lng": 144.5405513
  },
  {
    "name": "Brooklyn",
    "value": 37,
    "lat": -37.8160898,
    "lng": 144.8414748
  },
  {
    "name": "Brunswick",
    "value": 45,
    "lat": -37.7664715,
    "lng": 144.9613103
  },
  {
    "name": "Brunswick East",
    "value": 6,
    "lat": -37.7688802,
    "lng": 144.9776825
  },
  {
    "name": "Brunswick West",
    "value": 11,
    "lat": -37.7633334,
    "lng": 144.9425563
  },
  {
    "name": "Bulla",
    "value": 5,
    "lat": -37.6347957,
    "lng": 144.8027227
  },
  {
    "name": "Bulleen",
    "value": 30,
    "lat": -37.7688992,
    "lng": 145.0871992
  },
  {
    "name": "Bundoora",
    "value": 45,
    "lat": -37.6982468,
    "lng": 145.0596757
  },
  {
    "name": "Bungaree",
    "value": 1,
    "lat": -37.561704,
    "lng": 144.0040938
  },
  {
    "name": "Bunyip",
    "value": 5,
    "lat": -38.1302539,
    "lng": 145.6747869
  },
  {
    "name": "Burnley",
    "value": 4,
    "lat": -37.82762235,
    "lng": 145.0080911963464
  },
  {
    "name": "Burnside Heights",
    "value": 4,
    "lat": -37.7324225,
    "lng": 144.7555804
  },
  {
    "name": "Burwood",
    "value": 44,
    "lat": -37.849578,
    "lng": 145.1113915
  },
  {
    "name": "CHARLEMONT",
    "value": 27,
    "lat": -38.20975,
    "lng": 144.3686705
  },
  {
    "name": "CHIRNSIDE PARK",
    "value": 32,
    "lat": -37.9047634,
    "lng": 144.6530424
  },
  {
    "name": "CLARINDA",
    "value": 5,
    "lat": -37.9431093,
    "lng": 145.1060206
  },
  {
    "name": "CLYDE NTH",
    "value": 1,
    "lat": -38.1326419,
    "lng": 145.3380884
  },
  {
    "name": "CROYDON HILLS",
    "value": 1,
    "lat": -37.7743527,
    "lng": 145.2661042
  },
  {
    "name": "Cadello",
    "value": 2,
    "lat": -37.30576945,
    "lng": 144.5292792892011
  },
  {
    "name": "Cairnlea",
    "value": 8,
    "lat": -37.7593157,
    "lng": 144.7878098
  },
  {
    "name": "Calder Park",
    "value": 1,
    "lat": -37.672626949999994,
    "lng": 144.75641913491236
  },
  {
    "name": "Camberwell",
    "value": 35,
    "lat": -37.8384623,
    "lng": 145.0740767
  },
  {
    "name": "Campbellfield",
    "value": 30,
    "lat": -37.6641298,
    "lng": 144.959583
  },
  {
    "name": "Campbells Creek",
    "value": 2,
    "lat": -37.1064875,
    "lng": 144.21376737819
  },
  {
    "name": "Canterbury",
    "value": 21,
    "lat": -37.8247469,
    "lng": 145.0807636
  },
  {
    "name": "Cape Schanck",
    "value": 1,
    "lat": -38.49282875,
    "lng": 144.8864385754717
  },
  {
    "name": "Cardigan",
    "value": 1,
    "lat": -37.516795,
    "lng": 143.70994982898762
  },
  {
    "name": "Carlsruhe",
    "value": 1,
    "lat": -37.29059215,
    "lng": 144.49214226565852
  },
  {
    "name": "Carlton",
    "value": 51,
    "lat": -37.8004228,
    "lng": 144.9684343
  },
  {
    "name": "Carlton Gardens",
    "value": 3,
    "lat": -37.80625835,
    "lng": 144.97123311141877
  },
  {
    "name": "Carlton North",
    "value": 10,
    "lat": -37.7845585,
    "lng": 144.9728553
  },
  {
    "name": "Carnegie",
    "value": 9,
    "lat": -37.88622945,
    "lng": 145.05856954596675
  },
  {
    "name": "Caroline Springs",
    "value": 26,
    "lat": -37.7340623,
    "lng": 144.7370017
  },
  {
    "name": "Carrum",
    "value": 3,
    "lat": -38.07752515,
    "lng": 145.1230621504495
  },
  {
    "name": "Carrum Downs",
    "value": 21,
    "lat": -38.1003312,
    "lng": 145.1788657
  },
  {
    "name": "Castlemaine",
    "value": 2,
    "lat": -37.0664778,
    "lng": 144.2200032
  },
  {
    "name": "Caulfield",
    "value": 10,
    "lat": -37.8775177,
    "lng": 145.0424939
  },
  {
    "name": "Caulfield East",
    "value": 17,
    "lat": -37.8775177,
    "lng": 145.0424939
  },
  {
    "name": "Caulfield North",
    "value": 14,
    "lat": -37.881841800000004,
    "lng": 145.0394290297183
  },
  {
    "name": "Caulfield South",
    "value": 11,
    "lat": -37.894699,
    "lng": 145.0249323
  },
  {
    "name": "Chadstone",
    "value": 25,
    "lat": -37.8822799,
    "lng": 145.1001365
  },
  {
    "name": "Chadstone Centre",
    "value": 1,
    "lat": -37.8866236,
    "lng": 145.08239872867134
  },
  {
    "name": "Chelsea",
    "value": 7,
    "lat": -38.0497386,
    "lng": 145.121407
  },
  {
    "name": "Chelsea Heights",
    "value": 3,
    "lat": -38.0395381,
    "lng": 145.132786
  },
  {
    "name": "Cheltenham",
    "value": 111,
    "lat": -37.9634181,
    "lng": 145.0615668
  },
  {
    "name": "Christmas Hills",
    "value": 2,
    "lat": -37.6528089,
    "lng": 145.3206126
  },
  {
    "name": "Clayton",
    "value": 53,
    "lat": -37.9158025,
    "lng": 145.1313859
  },
  {
    "name": "Clayton South",
    "value": 17,
    "lat": -37.9320359,
    "lng": 145.1245064
  },
  {
    "name": "Clifton Hill",
    "value": 3,
    "lat": -37.7888762,
    "lng": 144.9953613
  },
  {
    "name": "Clifton springs",
    "value": 1,
    "lat": -38.15307,
    "lng": 144.5726575
  },
  {
    "name": "Clunes",
    "value": 2,
    "lat": -37.287625,
    "lng": 143.78029158071917
  },
  {
    "name": "Clyde",
    "value": 192,
    "lat": -38.1326345,
    "lng": 145.3290375
  },
  {
    "name": "Clyde North",
    "value": 567,
    "lat": -38.1028681,
    "lng": 145.3302814
  },
  {
    "name": "Cobblebank",
    "value": 29,
    "lat": -37.7063004,
    "lng": 144.6025657
  },
  {
    "name": "Cobram",
    "value": 1,
    "lat": -35.92430785,
    "lng": 145.6623798421739
  },
  {
    "name": "Coburg",
    "value": 39,
    "lat": -37.7449752,
    "lng": 144.9643314
  },
  {
    "name": "Coburg North",
    "value": 8,
    "lat": -37.72726350000001,
    "lng": 144.96785378723405
  },
  {
    "name": "Cockatoo",
    "value": 3,
    "lat": -37.9359421,
    "lng": 145.4932503
  },
  {
    "name": "Cocoroc",
    "value": 11,
    "lat": -37.9748784,
    "lng": 144.6286793
  },
  {
    "name": "Coimadai",
    "value": 1,
    "lat": -37.590415,
    "lng": 144.4881957
  },
  {
    "name": "Colac",
    "value": 5,
    "lat": -38.3399766,
    "lng": 143.5858537
  },
  {
    "name": "Colac East",
    "value": 2,
    "lat": -38.330477,
    "lng": 143.61696241711633
  },
  {
    "name": "Coldstream",
    "value": 2,
    "lat": -37.7291014,
    "lng": 145.378424
  },
  {
    "name": "Collingwood",
    "value": 14,
    "lat": -37.802104,
    "lng": 144.9881387
  },
  {
    "name": "Connewarre",
    "value": 2,
    "lat": -38.226253650000004,
    "lng": 144.45510371488666
  },
  {
    "name": "Coolaroo",
    "value": 5,
    "lat": -37.6612428,
    "lng": 144.92603114027156
  },
  {
    "name": "Coolingwwod",
    "value": 1,
    "lat": -36.5986096,
    "lng": 144.6780052
  },
  {
    "name": "Cora Lynn",
    "value": 3,
    "lat": -38.1436888,
    "lng": 145.6042711
  },
  {
    "name": "Coragulac",
    "value": 1,
    "lat": -38.2709198,
    "lng": 143.5198977
  },
  {
    "name": "Corio",
    "value": 19,
    "lat": -38.074088,
    "lng": 144.3586481
  },
  {
    "name": "Costerfield",
    "value": 1,
    "lat": -36.8702045,
    "lng": 144.79559403579952
  },
  {
    "name": "Cowes",
    "value": 3,
    "lat": -38.4502447,
    "lng": 145.2389787
  },
  {
    "name": "Craigieburn",
    "value": 148,
    "lat": -37.6022613,
    "lng": 144.9430882
  },
  {
    "name": "Cranbourne",
    "value": 53,
    "lat": -38.0997308,
    "lng": 145.2807256
  },
  {
    "name": "Cranbourne East",
    "value": 32,
    "lat": -38.1080912,
    "lng": 145.3056221
  },
  {
    "name": "Cranbourne North",
    "value": 17,
    "lat": -38.0775184,
    "lng": 145.2989039
  },
  {
    "name": "Cranbourne South",
    "value": 9,
    "lat": -38.1577683,
    "lng": 145.2624214
  },
  {
    "name": "Cranbourne West",
    "value": 51,
    "lat": -38.102241,
    "lng": 145.2517182
  },
  {
    "name": "Cremorne",
    "value": 18,
    "lat": -37.833534549999996,
    "lng": 144.99324704171715
  },
  {
    "name": "Creswick",
    "value": 1,
    "lat": -37.4245857,
    "lng": 143.8939669
  },
  {
    "name": "Crib Point",
    "value": 4,
    "lat": -38.365989600000006,
    "lng": 145.20414640852715
  },
  {
    "name": "Croydon",
    "value": 23,
    "lat": -37.7955004,
    "lng": 145.2801507
  },
  {
    "name": "Croydon North",
    "value": 3,
    "lat": -37.7737415,
    "lng": 145.2857882
  },
  {
    "name": "Croydon South",
    "value": 3,
    "lat": -37.8155329,
    "lng": 145.2780722
  },
  {
    "name": "Curlewis",
    "value": 4,
    "lat": -38.169525,
    "lng": 144.5458217
  },
  {
    "name": "DAYLESFORD",
    "value": 9,
    "lat": -37.3360085,
    "lng": 144.1524938
  },
  {
    "name": "DELACOMBE",
    "value": 1,
    "lat": -37.584019,
    "lng": 143.8172128
  },
  {
    "name": "Dallas",
    "value": 3,
    "lat": -37.66878645,
    "lng": 144.937052864207
  },
  {
    "name": "Dandenong",
    "value": 77,
    "lat": -37.9901275,
    "lng": 145.20982829306604
  },
  {
    "name": "Dandenong North",
    "value": 19,
    "lat": -37.9558319,
    "lng": 145.2143234
  },
  {
    "name": "Dandenong South",
    "value": 93,
    "lat": -38.0279936,
    "lng": 145.2209236
  },
  {
    "name": "Dandenong VIC.",
    "value": 1,
    "lat": -37.9775284,
    "lng": 145.2133987
  },
  {
    "name": "Darley",
    "value": 15,
    "lat": -37.6365605,
    "lng": 144.43221253384922
  },
  {
    "name": "Deanside",
    "value": 162,
    "lat": -37.729087,
    "lng": 144.704081
  },
  {
    "name": "Deepdene",
    "value": 2,
    "lat": -37.8121234,
    "lng": 145.0664377
  },
  {
    "name": "Deer Park",
    "value": 12,
    "lat": -37.7686602,
    "lng": 144.7713077
  },
  {
    "name": "Delahey",
    "value": 5,
    "lat": -37.71913095,
    "lng": 144.7720760215439
  },
  {
    "name": "Derrimut",
    "value": 50,
    "lat": -37.7987978,
    "lng": 144.776051
  },
  {
    "name": "Devon Meadows",
    "value": 6,
    "lat": -38.1620178,
    "lng": 145.3024933
  },
  {
    "name": "Diamond Creek",
    "value": 15,
    "lat": -37.6733272,
    "lng": 145.1588075
  },
  {
    "name": "Diggers Rest",
    "value": 37,
    "lat": -37.6275995,
    "lng": 144.7200075
  },
  {
    "name": "Dingley Village",
    "value": 16,
    "lat": -37.9755762,
    "lng": 145.1256478
  },
  {
    "name": "Docklands",
    "value": 72,
    "lat": -37.8175423,
    "lng": 144.9394923
  },
  {
    "name": "Doncaster",
    "value": 122,
    "lat": -37.7848299,
    "lng": 145.1238431
  },
  {
    "name": "Doncaster East",
    "value": 11,
    "lat": -37.7836468,
    "lng": 145.1584717848988
  },
  {
    "name": "Doncaster]",
    "value": 1,
    "lat": -37.7848299,
    "lng": 145.1238431
  },
  {
    "name": "Donnybrook",
    "value": 170,
    "lat": -37.5419879,
    "lng": 144.9702272
  },
  {
    "name": "Donvale",
    "value": 14,
    "lat": -37.77243895,
    "lng": 145.18566726274176
  },
  {
    "name": "Doreen",
    "value": 47,
    "lat": -37.5963874,
    "lng": 145.1428928
  },
  {
    "name": "Doveton",
    "value": 12,
    "lat": -37.9865853,
    "lng": 145.2371568181206
  },
  {
    "name": "Dr DONNYBROOK",
    "value": 1,
    "lat": -37.5427836,
    "lng": 144.9702565
  },
  {
    "name": "Dromana",
    "value": 8,
    "lat": -38.3418285,
    "lng": 144.9655838
  },
  {
    "name": "Drouin",
    "value": 15,
    "lat": -38.1361683,
    "lng": 145.8564344
  },
  {
    "name": "Drouin West",
    "value": 1,
    "lat": -38.0871336,
    "lng": 145.8735458
  },
  {
    "name": "Drummond North",
    "value": 1,
    "lat": -37.19384585,
    "lng": 144.32356979241894
  },
  {
    "name": "Drysdale",
    "value": 6,
    "lat": -38.1728304,
    "lng": 144.5710723
  },
  {
    "name": "EYNESBURY VIC",
    "value": 1,
    "lat": -37.7908381,
    "lng": 144.5561657
  },
  {
    "name": "Eaglemont",
    "value": 6,
    "lat": -37.7637393,
    "lng": 145.0537729
  },
  {
    "name": "East Bendigo",
    "value": 2,
    "lat": -36.7335051,
    "lng": 144.32925676182253
  },
  {
    "name": "East Geelong",
    "value": 6,
    "lat": -38.152805,
    "lng": 144.37404164244722
  },
  {
    "name": "East Keilor",
    "value": 1,
    "lat": -37.7295638,
    "lng": 144.7938135
  },
  {
    "name": "East Melbourne",
    "value": 20,
    "lat": -37.819908999999996,
    "lng": 144.98322500667754
  },
  {
    "name": "East Ringwood",
    "value": 1,
    "lat": -37.8117518,
    "lng": 145.2499467
  },
  {
    "name": "Echuca",
    "value": 1,
    "lat": -36.1281405,
    "lng": 144.7516955
  },
  {
    "name": "Eden Park",
    "value": 1,
    "lat": -37.4950097,
    "lng": 145.071621
  },
  {
    "name": "Edithvale",
    "value": 3,
    "lat": -38.0365014,
    "lng": 145.1075976
  },
  {
    "name": "Elaine",
    "value": 1,
    "lat": -37.761595,
    "lng": 144.0062833
  },
  {
    "name": "Elliminyt",
    "value": 3,
    "lat": -38.3673988,
    "lng": 143.5828729
  },
  {
    "name": "Elmhurst",
    "value": 1,
    "lat": -37.1687275,
    "lng": 143.2511709025049
  },
  {
    "name": "Elsternwick",
    "value": 13,
    "lat": -37.88499375,
    "lng": 145.0010230968834
  },
  {
    "name": "Eltham",
    "value": 10,
    "lat": -37.71373595,
    "lng": 145.14767304321788
  },
  {
    "name": "Eltham North",
    "value": 5,
    "lat": -37.6978921,
    "lng": 145.1417807
  },
  {
    "name": "Elwood",
    "value": 15,
    "lat": -37.8819945,
    "lng": 144.98538770441866
  },
  {
    "name": "Emerald",
    "value": 3,
    "lat": -37.9321282,
    "lng": 145.4407282
  },
  {
    "name": "Endeavour Hills",
    "value": 9,
    "lat": -37.9702665,
    "lng": 145.2563443
  },
  {
    "name": "Endevour Hills",
    "value": 1,
    "lat": -36.4494431,
    "lng": 142.0231605
  },
  {
    "name": "Epping",
    "value": 84,
    "lat": -37.6523847,
    "lng": 145.0315487436747
  },
  {
    "name": "Essendon",
    "value": 39,
    "lat": -37.7560691,
    "lng": 144.9160228
  },
  {
    "name": "Essendon Fields",
    "value": 18,
    "lat": -37.72660985,
    "lng": 144.90131801511075
  },
  {
    "name": "Essendon North",
    "value": 2,
    "lat": -37.7384762,
    "lng": 144.9012027
  },
  {
    "name": "Essendon West",
    "value": 2,
    "lat": -37.7528304,
    "lng": 144.8845846
  },
  {
    "name": "Eumemmerring",
    "value": 2,
    "lat": -37.9985273,
    "lng": 145.2469497
  },
  {
    "name": "Euroa",
    "value": 1,
    "lat": -36.773286,
    "lng": 145.58293099936913
  },
  {
    "name": "Eynesbury",
    "value": 24,
    "lat": -37.7908381,
    "lng": 144.5561657
  },
  {
    "name": "FYANSFORD",
    "value": 2,
    "lat": -38.1416752,
    "lng": 144.3096802
  },
  {
    "name": "Fairfield",
    "value": 10,
    "lat": -37.7791763,
    "lng": 145.0169241
  },
  {
    "name": "Fawkner",
    "value": 15,
    "lat": -37.70364055,
    "lng": 144.97156616581034
  },
  {
    "name": "Ferntree Gully",
    "value": 37,
    "lat": -37.8815825,
    "lng": 145.2951466
  },
  {
    "name": "Fingal",
    "value": 2,
    "lat": -38.4151313,
    "lng": 144.8511313
  },
  {
    "name": "Fitzroy",
    "value": 25,
    "lat": -37.8010382,
    "lng": 144.9792611
  },
  {
    "name": "Fitzroy North",
    "value": 8,
    "lat": -37.78513865,
    "lng": 144.987826521994
  },
  {
    "name": "Flemington",
    "value": 138,
    "lat": -37.78925135,
    "lng": 144.9127712588256
  },
  {
    "name": "Fleminton",
    "value": 1,
    "lat": -37.8072542,
    "lng": 144.9778465
  },
  {
    "name": "Flemngton",
    "value": 1,
    "lat": -37.8072542,
    "lng": 144.9778465
  },
  {
    "name": "Flinders",
    "value": 4,
    "lat": -37.8183366,
    "lng": 144.9667401
  },
  {
    "name": "Flora Hill",
    "value": 2,
    "lat": -36.7781198,
    "lng": 144.2984448
  },
  {
    "name": "Footscray",
    "value": 70,
    "lat": -37.7981339,
    "lng": 144.897345
  },
  {
    "name": "Forest Hill",
    "value": 38,
    "lat": -37.8489562,
    "lng": 145.16237861533313
  },
  {
    "name": "Fountain Gate",
    "value": 5,
    "lat": -38.01881785,
    "lng": 145.3038708376251
  },
  {
    "name": "Frankston",
    "value": 67,
    "lat": -38.1457064,
    "lng": 145.1263742
  },
  {
    "name": "Frankston North",
    "value": 12,
    "lat": -38.1228524,
    "lng": 145.1609788
  },
  {
    "name": "Frankston South",
    "value": 10,
    "lat": -38.1765027,
    "lng": 145.1295641
  },
  {
    "name": "Fraser Rise",
    "value": 137,
    "lat": -37.7059863,
    "lng": 144.7174013
  },
  {
    "name": "Freshwater Creek",
    "value": 1,
    "lat": -38.2565704,
    "lng": 144.2753824
  },
  {
    "name": "Gardenvale",
    "value": 4,
    "lat": -37.8966425,
    "lng": 145.0041759
  },
  {
    "name": "Garfield",
    "value": 3,
    "lat": -38.0898677,
    "lng": 145.676222
  },
  {
    "name": "Garfiled North",
    "value": 1,
    "lat": -38.0898677,
    "lng": 145.676222
  },
  {
    "name": "Geelong",
    "value": 92,
    "lat": -38.1493248,
    "lng": 144.3598241
  },
  {
    "name": "Geelong West",
    "value": 16,
    "lat": -38.1392967,
    "lng": 144.3450387
  },
  {
    "name": "Gembrook",
    "value": 3,
    "lat": -37.9521016,
    "lng": 145.5495811
  },
  {
    "name": "Gilderoy",
    "value": 1,
    "lat": -37.8547073,
    "lng": 145.7128179
  },
  {
    "name": "Gisborne",
    "value": 52,
    "lat": -37.486723,
    "lng": 144.5904237
  },
  {
    "name": "Gisborne South",
    "value": 2,
    "lat": -37.545666,
    "lng": 144.6199034
  },
  {
    "name": "Gisbourne",
    "value": 1,
    "lat": -27.6621822,
    "lng": 153.0031321
  },
  {
    "name": "Gladstone Park",
    "value": 3,
    "lat": -37.6886043,
    "lng": 144.89038494285714
  },
  {
    "name": "Glen Huntly",
    "value": 5,
    "lat": -37.8893136,
    "lng": 145.042285
  },
  {
    "name": "Glen Iris",
    "value": 22,
    "lat": -37.855814,
    "lng": 145.0646117
  },
  {
    "name": "Glen Park",
    "value": 1,
    "lat": -37.507508,
    "lng": 143.9231129
  },
  {
    "name": "Glen Waverley",
    "value": 76,
    "lat": -37.8794953,
    "lng": 145.1622842
  },
  {
    "name": "Glenmaggie",
    "value": 1,
    "lat": -37.823677,
    "lng": 146.71033388103837
  },
  {
    "name": "Glenroy",
    "value": 30,
    "lat": -37.7044232,
    "lng": 144.91733510124274
  },
  {
    "name": "Gnarwarre",
    "value": 6,
    "lat": -38.1696975,
    "lng": 144.1590974
  },
  {
    "name": "Golden Point",
    "value": 1,
    "lat": -37.5737773,
    "lng": 143.86488550102143
  },
  {
    "name": "Goorambat",
    "value": 2,
    "lat": -36.414167500000005,
    "lng": 145.9531842999661
  },
  {
    "name": "Gowanbrae",
    "value": 1,
    "lat": -37.7027183,
    "lng": 144.8975976
  },
  {
    "name": "Grand Prix",
    "value": 1,
    "lat": -38.504080450000004,
    "lng": 145.2345538285926
  },
  {
    "name": "Greensborough",
    "value": 31,
    "lat": -37.7037383,
    "lng": 145.10791052131128
  },
  {
    "name": "Greenvale",
    "value": 77,
    "lat": -37.62655075,
    "lng": 144.90003733868005
  },
  {
    "name": "Grovedale",
    "value": 8,
    "lat": -38.21039495,
    "lng": 144.32832508089706
  },
  {
    "name": "Gruyere",
    "value": 1,
    "lat": -37.7342172,
    "lng": 145.4502423
  },
  {
    "name": "Hadfield",
    "value": 4,
    "lat": -37.7101582,
    "lng": 144.9502764
  },
  {
    "name": "Hallam",
    "value": 12,
    "lat": -38.0179565,
    "lng": 145.27031306867752
  },
  {
    "name": "Hamlyn Heights",
    "value": 6,
    "lat": -38.123975200000004,
    "lng": 144.3292568499673
  },
  {
    "name": "Hampton",
    "value": 21,
    "lat": -37.9381127,
    "lng": 145.0014764
  },
  {
    "name": "Hampton East",
    "value": 4,
    "lat": -37.9385409,
    "lng": 145.0306726
  },
  {
    "name": "Hampton Park",
    "value": 17,
    "lat": -38.0367368,
    "lng": 145.2590312
  },
  {
    "name": "Harkaway",
    "value": 3,
    "lat": -38.0002695,
    "lng": 145.3416887
  },
  {
    "name": "Harkness",
    "value": 4,
    "lat": -37.6567808,
    "lng": 144.5525264
  },
  {
    "name": "Hastings",
    "value": 8,
    "lat": -38.3056058,
    "lng": 145.1859934
  },
  {
    "name": "Hastings MORNINGTON PENINSULA",
    "value": 3,
    "lat": -38.3082592,
    "lng": 145.1945672
  },
  {
    "name": "Hawthorn",
    "value": 28,
    "lat": -37.8244246,
    "lng": 145.0317207
  },
  {
    "name": "Hawthorn East",
    "value": 15,
    "lat": -37.8313785,
    "lng": 145.0499797
  },
  {
    "name": "Hazelwood North",
    "value": 3,
    "lat": -38.273497,
    "lng": 146.4878942
  },
  {
    "name": "Healesville",
    "value": 6,
    "lat": -37.6537218,
    "lng": 145.5161533
  },
  {
    "name": "Heathcote",
    "value": 1,
    "lat": -36.9160908,
    "lng": 144.7033003
  },
  {
    "name": "Heatherton",
    "value": 20,
    "lat": -37.9560844,
    "lng": 145.0932067
  },
  {
    "name": "Heathmont",
    "value": 7,
    "lat": -37.8283636,
    "lng": 145.244577
  },
  {
    "name": "Heidelberg",
    "value": 16,
    "lat": -37.7524788,
    "lng": 145.0701284
  },
  {
    "name": "Heidelberg Heights",
    "value": 8,
    "lat": -37.7451831,
    "lng": 145.0529194
  },
  {
    "name": "Heidelberg West",
    "value": 8,
    "lat": -37.7382431,
    "lng": 145.0433922
  },
  {
    "name": "Herne Hill",
    "value": 1,
    "lat": -38.1341943,
    "lng": 144.3245385
  },
  {
    "name": "Hesket",
    "value": 1,
    "lat": -37.356132,
    "lng": 144.6326392
  },
  {
    "name": "Highett",
    "value": 16,
    "lat": -37.9484438,
    "lng": 145.04188
  },
  {
    "name": "Highton",
    "value": 5,
    "lat": -38.1709191,
    "lng": 144.3190212
  },
  {
    "name": "Hillside",
    "value": 12,
    "lat": -37.6904862,
    "lng": 144.7417358
  },
  {
    "name": "Hmas Cerberus",
    "value": 6,
    "lat": -38.3827748,
    "lng": 145.1944475
  },
  {
    "name": "Hopetoun Park",
    "value": 1,
    "lat": -37.6950368,
    "lng": 144.5016361
  },
  {
    "name": "Hoppers Crossing",
    "value": 44,
    "lat": -37.870174,
    "lng": 144.69607084271246
  },
  {
    "name": "Hughesdale",
    "value": 6,
    "lat": -37.8938651,
    "lng": 145.0755107223269
  },
  {
    "name": "Humevale",
    "value": 1,
    "lat": -37.497861,
    "lng": 145.1802277
  },
  {
    "name": "Huntingdale",
    "value": 1,
    "lat": -37.9107647,
    "lng": 145.1020573
  },
  {
    "name": "Huntly",
    "value": 4,
    "lat": -36.6629455,
    "lng": 144.3344307
  },
  {
    "name": "Indented Head",
    "value": 1,
    "lat": -38.1397178,
    "lng": 144.7094652
  },
  {
    "name": "Ingliston",
    "value": 4,
    "lat": -37.660045499999995,
    "lng": 144.30868448910905
  },
  {
    "name": "Inverleigh",
    "value": 2,
    "lat": -38.1016454,
    "lng": 144.0573333
  },
  {
    "name": "Inverloch",
    "value": 2,
    "lat": -38.6331582,
    "lng": 145.7279504
  },
  {
    "name": "Ivanhoe",
    "value": 19,
    "lat": -37.7688774,
    "lng": 145.0454487
  },
  {
    "name": "Ivanhoe East",
    "value": 8,
    "lat": -37.7733903,
    "lng": 145.0617815
  },
  {
    "name": "Junction Village",
    "value": 7,
    "lat": -38.1363443,
    "lng": 145.2968697
  },
  {
    "name": "KALKALLO",
    "value": 69,
    "lat": -37.5309523,
    "lng": 144.9496539
  },
  {
    "name": "KINGS PARK",
    "value": 2,
    "lat": -37.7317965,
    "lng": 144.7698864
  },
  {
    "name": "KINGSBURY",
    "value": 2,
    "lat": -37.715569,
    "lng": 145.0355601
  },
  {
    "name": "KURUNJANG",
    "value": 5,
    "lat": -37.6721451,
    "lng": 144.5846358
  },
  {
    "name": "Kallista",
    "value": 1,
    "lat": -37.8858076,
    "lng": 145.3729123
  },
  {
    "name": "Kangaroo Flat",
    "value": 2,
    "lat": -36.806233000000006,
    "lng": 144.24078666059603
  },
  {
    "name": "Kangaroo Ground",
    "value": 2,
    "lat": -37.6918649,
    "lng": 145.2158904
  },
  {
    "name": "Kealba",
    "value": 1,
    "lat": -37.7371074,
    "lng": 144.8282988
  },
  {
    "name": "Keilor",
    "value": 5,
    "lat": -37.7113545,
    "lng": 144.8250696
  },
  {
    "name": "Keilor Downs",
    "value": 12,
    "lat": -37.7205762,
    "lng": 144.8047614
  },
  {
    "name": "Keilor East",
    "value": 21,
    "lat": -37.7295638,
    "lng": 144.7938135
  },
  {
    "name": "Keilor Lodge",
    "value": 1,
    "lat": -37.6984134,
    "lng": 144.7998157
  },
  {
    "name": "Keilor Park",
    "value": 10,
    "lat": -37.7187247,
    "lng": 144.8501721
  },
  {
    "name": "Kennett River",
    "value": 1,
    "lat": -38.6676956,
    "lng": 143.85892
  },
  {
    "name": "Kensignton",
    "value": 1,
    "lat": -36.5986096,
    "lng": 144.6780052
  },
  {
    "name": "Kensington",
    "value": 11,
    "lat": -37.7939378,
    "lng": 144.9305645
  },
  {
    "name": "Kew",
    "value": 44,
    "lat": -37.8033586,
    "lng": 145.0333285
  },
  {
    "name": "Kew East",
    "value": 9,
    "lat": -37.7904215,
    "lng": 145.0527906
  },
  {
    "name": "Keysborough",
    "value": 40,
    "lat": -38.004856849999996,
    "lng": 145.16239832778558
  },
  {
    "name": "Kialla",
    "value": 1,
    "lat": -36.445075,
    "lng": 145.40645777040532
  },
  {
    "name": "Kilmore",
    "value": 26,
    "lat": -37.2922688,
    "lng": 144.9510311
  },
  {
    "name": "Kilsyth",
    "value": 13,
    "lat": -37.8037844,
    "lng": 145.3134593
  },
  {
    "name": "Kilsyth South",
    "value": 1,
    "lat": -37.8315054,
    "lng": 145.3110008
  },
  {
    "name": "Kinglake",
    "value": 1,
    "lat": -37.5327424,
    "lng": 145.341131
  },
  {
    "name": "Kinglake Central",
    "value": 1,
    "lat": -37.469218,
    "lng": 145.3250896
  },
  {
    "name": "Kinglake West",
    "value": 1,
    "lat": -37.450214,
    "lng": 145.258423
  },
  {
    "name": "Kingsville",
    "value": 2,
    "lat": -37.8088622,
    "lng": 144.8794356
  },
  {
    "name": "Knowsley",
    "value": 1,
    "lat": -36.827433,
    "lng": 144.59767955328036
  },
  {
    "name": "Knox",
    "value": 38,
    "lat": -37.898453,
    "lng": 145.2648563164172
  },
  {
    "name": "Knoxfield",
    "value": 23,
    "lat": -37.8897731,
    "lng": 145.2496342
  },
  {
    "name": "Koo Wee Rup",
    "value": 4,
    "lat": -38.1990553,
    "lng": 145.492854
  },
  {
    "name": "Kooyong",
    "value": 3,
    "lat": -37.841394,
    "lng": 145.0358402
  },
  {
    "name": "Korumburra",
    "value": 1,
    "lat": -38.4321809,
    "lng": 145.8236012
  },
  {
    "name": "Kyneton",
    "value": 4,
    "lat": -37.247494,
    "lng": 144.4552171
  },
  {
    "name": "LALOR",
    "value": 16,
    "lat": -37.662922,
    "lng": 145.003955
  },
  {
    "name": "LYNDHURST",
    "value": 3,
    "lat": -38.0685384,
    "lng": 145.2307493
  },
  {
    "name": "Lake Wendouree",
    "value": 4,
    "lat": -37.5501895,
    "lng": 143.83503056464738
  },
  {
    "name": "Lakes Entrance",
    "value": 1,
    "lat": -37.877796,
    "lng": 148.0023918
  },
  {
    "name": "Lancaster",
    "value": 1,
    "lat": -36.298938,
    "lng": 145.1360720282176
  },
  {
    "name": "Lancefield",
    "value": 4,
    "lat": -37.2763273,
    "lng": 144.7340354
  },
  {
    "name": "Lang Lang",
    "value": 4,
    "lat": -38.2660405,
    "lng": 145.5627778
  },
  {
    "name": "Langwarrin",
    "value": 8,
    "lat": -38.1545829,
    "lng": 145.1973931
  },
  {
    "name": "Langwarrin South",
    "value": 3,
    "lat": -38.1891024,
    "lng": 145.1910633
  },
  {
    "name": "Lara",
    "value": 88,
    "lat": -38.0235346,
    "lng": 144.4088294
  },
  {
    "name": "Lardner",
    "value": 2,
    "lat": -38.2181015,
    "lng": 145.8738981
  },
  {
    "name": "Laverton",
    "value": 17,
    "lat": -37.8637978,
    "lng": 144.7723486
  },
  {
    "name": "Laverton North",
    "value": 85,
    "lat": -37.84227635,
    "lng": 144.78835195840344
  },
  {
    "name": "Laverton Yard",
    "value": 1,
    "lat": -37.8593822,
    "lng": 144.7671404
  },
  {
    "name": "Leongatha",
    "value": 1,
    "lat": -38.4761569,
    "lng": 145.9458605
  },
  {
    "name": "Leopold",
    "value": 9,
    "lat": -38.1891547,
    "lng": 144.4644962
  },
  {
    "name": "Lilydale",
    "value": 18,
    "lat": -37.7571582,
    "lng": 145.34586560554067
  },
  {
    "name": "Little River",
    "value": 5,
    "lat": -37.9639273,
    "lng": 144.5009868
  },
  {
    "name": "Long Gully",
    "value": 2,
    "lat": -36.7431555,
    "lng": 144.25903949892242
  },
  {
    "name": "Longwarry",
    "value": 1,
    "lat": -38.1258285,
    "lng": 145.76549109868236
  },
  {
    "name": "Lorne",
    "value": 4,
    "lat": -38.5411691,
    "lng": 143.9748166
  },
  {
    "name": "Lovely Banks",
    "value": 1,
    "lat": -38.065017,
    "lng": 144.3269872054356
  },
  {
    "name": "Lower Plenty",
    "value": 4,
    "lat": -37.7388437,
    "lng": 145.116224
  },
  {
    "name": "Loy Yang",
    "value": 1,
    "lat": -38.2498963,
    "lng": 146.5752857
  },
  {
    "name": "Lucas",
    "value": 2,
    "lat": -37.5521665,
    "lng": 143.7696838
  },
  {
    "name": "Lynbrook",
    "value": 5,
    "lat": -38.0558639,
    "lng": 145.2561128
  },
  {
    "name": "Lysterfield",
    "value": 5,
    "lat": -37.9348771,
    "lng": 145.3017588
  },
  {
    "name": "Lysterfield South",
    "value": 1,
    "lat": -37.9524844,
    "lng": 145.2669275
  },
  {
    "name": "MANOR LAKES",
    "value": 125,
    "lat": -37.8686285,
    "lng": 144.5950127
  },
  {
    "name": "MEADOW HEIGHTS",
    "value": 3,
    "lat": -37.6511668,
    "lng": 144.9185521
  },
  {
    "name": "MELTON SOUTH",
    "value": 57,
    "lat": -37.7060279,
    "lng": 144.5717723
  },
  {
    "name": "MELTON STH",
    "value": 1,
    "lat": -37.6823524,
    "lng": 144.566826
  },
  {
    "name": "MILLGROVE",
    "value": 3,
    "lat": -37.7515012,
    "lng": 145.6612026
  },
  {
    "name": "MONTROSE",
    "value": 6,
    "lat": -37.8099664,
    "lng": 145.342401
  },
  {
    "name": "MORWELL",
    "value": 6,
    "lat": -38.2363218,
    "lng": 146.3977575
  },
  {
    "name": "Macclesfield",
    "value": 1,
    "lat": -37.887001,
    "lng": 145.475186
  },
  {
    "name": "Macedon",
    "value": 2,
    "lat": -37.3336305,
    "lng": 144.63464116524977
  },
  {
    "name": "Macleod",
    "value": 10,
    "lat": -37.72607,
    "lng": 145.0691378
  },
  {
    "name": "Maddingley",
    "value": 15,
    "lat": -37.6974706,
    "lng": 144.4194664
  },
  {
    "name": "Magpie",
    "value": 1,
    "lat": -37.6324345,
    "lng": 143.84506221603834
  },
  {
    "name": "Maiden Gully",
    "value": 3,
    "lat": -36.7558305,
    "lng": 144.2075728577693
  },
  {
    "name": "Maidstone",
    "value": 13,
    "lat": -37.7753803,
    "lng": 144.87482090704123
  },
  {
    "name": "Malmsbury",
    "value": 1,
    "lat": -37.1879056,
    "lng": 144.3956641
  },
  {
    "name": "Malvern",
    "value": 29,
    "lat": -37.8576088,
    "lng": 145.0350666
  },
  {
    "name": "Malvern East",
    "value": 32,
    "lat": -37.8768464,
    "lng": 145.0691723
  },
  {
    "name": "Mambourin",
    "value": 57,
    "lat": -37.8908261,
    "lng": 144.5947762
  },
  {
    "name": "Manifold Heights",
    "value": 2,
    "lat": -38.1374209,
    "lng": 144.3337974
  },
  {
    "name": "Manningham",
    "value": 1,
    "lat": -37.75708315,
    "lng": 145.18521481430855
  },
  {
    "name": "Manor Lakes Village",
    "value": 1,
    "lat": -37.8686285,
    "lng": 144.5950127
  },
  {
    "name": "Marcus Hill",
    "value": 1,
    "lat": -38.2417526,
    "lng": 144.5726976
  },
  {
    "name": "Maribyrnong",
    "value": 16,
    "lat": -37.791372499999994,
    "lng": 144.87429008189554
  },
  {
    "name": "Maryborough",
    "value": 1,
    "lat": -37.0467582,
    "lng": 143.7375721
  },
  {
    "name": "McCrae",
    "value": 2,
    "lat": -38.3599791,
    "lng": 144.9338501
  },
  {
    "name": "McKinnon",
    "value": 3,
    "lat": -37.9114854,
    "lng": 145.0380898
  },
  {
    "name": "Meadows",
    "value": 1,
    "lat": -37.8814419,
    "lng": 144.7845482
  },
  {
    "name": "Melbourne",
    "value": 438,
    "lat": -37.8142454,
    "lng": 144.9631732
  },
  {
    "name": "Melbourne Airport",
    "value": 92,
    "lat": -37.6667554,
    "lng": 144.8288501411705
  },
  {
    "name": "Melbourne CBD",
    "value": 4,
    "lat": -37.8152042,
    "lng": 144.9604909
  },
  {
    "name": "Melton",
    "value": 44,
    "lat": -37.6835714,
    "lng": 144.5828446
  },
  {
    "name": "Melton West",
    "value": 14,
    "lat": -37.68060965,
    "lng": 144.56716396518243
  },
  {
    "name": "Mentone",
    "value": 25,
    "lat": -37.98277325,
    "lng": 145.06579803133945
  },
  {
    "name": "Meredith",
    "value": 1,
    "lat": -37.8436639,
    "lng": 144.0754653
  },
  {
    "name": "Mernda",
    "value": 43,
    "lat": -37.6025021,
    "lng": 145.1009024
  },
  {
    "name": "Merricks",
    "value": 1,
    "lat": -38.3520225,
    "lng": 145.0756643
  },
  {
    "name": "Merrijig",
    "value": 1,
    "lat": -37.658208,
    "lng": 147.43162475145954
  },
  {
    "name": "Metcalfe",
    "value": 1,
    "lat": -37.093672999999995,
    "lng": 144.4371823550099
  },
  {
    "name": "Mickleham",
    "value": 214,
    "lat": -37.5344793,
    "lng": 144.9120372
  },
  {
    "name": "Middle Park",
    "value": 5,
    "lat": -37.8511511,
    "lng": 144.9620399
  },
  {
    "name": "Mill Park",
    "value": 22,
    "lat": -37.6641334,
    "lng": 145.0642681
  },
  {
    "name": "Miners Rest",
    "value": 1,
    "lat": -37.4845541,
    "lng": 143.8029124
  },
  {
    "name": "Minyip",
    "value": 1,
    "lat": -36.4612399,
    "lng": 142.5871266
  },
  {
    "name": "Mitcham",
    "value": 31,
    "lat": -37.8180929,
    "lng": 145.1928003
  },
  {
    "name": "Mitchell Park",
    "value": 13,
    "lat": -37.649650449999996,
    "lng": 147.3489915304714
  },
  {
    "name": "Moe",
    "value": 2,
    "lat": -38.177049,
    "lng": 146.2619888
  },
  {
    "name": "Monbulk",
    "value": 6,
    "lat": -37.8741771,
    "lng": 145.4286024
  },
  {
    "name": "Mont Albert",
    "value": 5,
    "lat": -37.8175479,
    "lng": 145.1075721
  },
  {
    "name": "Mont Albert North",
    "value": 25,
    "lat": -37.8033152,
    "lng": 145.1107226
  },
  {
    "name": "Montmorency",
    "value": 5,
    "lat": -37.7189715,
    "lng": 145.1256231
  },
  {
    "name": "Moolap",
    "value": 6,
    "lat": -38.1802637,
    "lng": 144.4249159
  },
  {
    "name": "Moonee Ponds",
    "value": 34,
    "lat": -37.765935,
    "lng": 144.9192614
  },
  {
    "name": "Moorabbin",
    "value": 24,
    "lat": -37.97845745,
    "lng": 145.09835525579624
  },
  {
    "name": "Moorabbin Airport",
    "value": 15,
    "lat": -37.97845745,
    "lng": 145.09835525579624
  },
  {
    "name": "Moorabin Airport",
    "value": 1,
    "lat": -37.9784574,
    "lng": 145.0983553
  },
  {
    "name": "Moorooduc",
    "value": 6,
    "lat": -38.2431787,
    "lng": 145.1153474
  },
  {
    "name": "Mooroolbark",
    "value": 7,
    "lat": -37.784697,
    "lng": 145.3131856
  },
  {
    "name": "Mooroopna",
    "value": 2,
    "lat": -36.3944882,
    "lng": 145.360182
  },
  {
    "name": "Mordialloc",
    "value": 15,
    "lat": -38.0067174,
    "lng": 145.0875658
  },
  {
    "name": "Moriac",
    "value": 2,
    "lat": -38.2452578,
    "lng": 144.1725521
  },
  {
    "name": "Mornington",
    "value": 20,
    "lat": -38.2202151,
    "lng": 145.0411089
  },
  {
    "name": "Mount Cottrell",
    "value": 11,
    "lat": -37.7858441,
    "lng": 144.6243883
  },
  {
    "name": "Mount Dandenong",
    "value": 1,
    "lat": -37.8366965,
    "lng": 145.35135741947994
  },
  {
    "name": "Mount Duneed",
    "value": 55,
    "lat": -38.2316529,
    "lng": 144.3170763
  },
  {
    "name": "Mount Eliza",
    "value": 34,
    "lat": -38.19027015,
    "lng": 145.09246799372391
  },
  {
    "name": "Mount Evelyn",
    "value": 10,
    "lat": -37.7873186,
    "lng": 145.3883037
  },
  {
    "name": "Mount Martha",
    "value": 15,
    "lat": -38.2754676,
    "lng": 145.0307737
  },
  {
    "name": "Mount Pleasant",
    "value": 1,
    "lat": -37.581745999999995,
    "lng": 143.85506860398647
  },
  {
    "name": "Mount Waverley",
    "value": 78,
    "lat": -37.8752637,
    "lng": 145.1281258
  },
  {
    "name": "Mt Cottrell",
    "value": 1,
    "lat": -37.7858441,
    "lng": 144.6243883
  },
  {
    "name": "Mt Waverly",
    "value": 1,
    "lat": -37.9255806,
    "lng": 145.18875070445546
  },
  {
    "name": "Mt.Martha",
    "value": 7,
    "lat": -36.132930546720296,
    "lng": 147.00184885415075
  },
  {
    "name": "Mulgrave",
    "value": 52,
    "lat": -37.9261741,
    "lng": 145.1723107
  },
  {
    "name": "Murgheboluc",
    "value": 1,
    "lat": -38.106659,
    "lng": 144.1405946
  },
  {
    "name": "Murrayville",
    "value": 1,
    "lat": -35.2625514,
    "lng": 141.1826485
  },
  {
    "name": "Murrumbeena",
    "value": 5,
    "lat": -37.890314950000004,
    "lng": 145.06759718129234
  },
  {
    "name": "Musk",
    "value": 1,
    "lat": -37.3682655,
    "lng": 144.1965729632767
  },
  {
    "name": "NILMA",
    "value": 3,
    "lat": -38.1711312,
    "lng": 145.9672035
  },
  {
    "name": "Nar Nar Goon",
    "value": 43,
    "lat": -38.08215,
    "lng": 145.5702129
  },
  {
    "name": "Nar Nar Goon North",
    "value": 25,
    "lat": -38.029345,
    "lng": 145.5652791
  },
  {
    "name": "Narre Warren",
    "value": 133,
    "lat": -38.0275167,
    "lng": 145.3037690879916
  },
  {
    "name": "Narre Warren East",
    "value": 1,
    "lat": -37.9627116,
    "lng": 145.361856
  },
  {
    "name": "Narre Warren North",
    "value": 10,
    "lat": -37.9813391,
    "lng": 145.3129016
  },
  {
    "name": "Narre Warren South",
    "value": 11,
    "lat": -38.05439,
    "lng": 145.3028513
  },
  {
    "name": "New Gisborne",
    "value": 6,
    "lat": -37.458962299999996,
    "lng": 144.5990125919589
  },
  {
    "name": "Newborough",
    "value": 8,
    "lat": -38.1850569,
    "lng": 146.2904653
  },
  {
    "name": "Newcomb",
    "value": 5,
    "lat": -38.1631764,
    "lng": 144.39533
  },
  {
    "name": "Newhaven",
    "value": 1,
    "lat": -38.5150092,
    "lng": 145.3607644
  },
  {
    "name": "Newington",
    "value": 1,
    "lat": -37.564199,
    "lng": 143.82775744167648
  },
  {
    "name": "Newport",
    "value": 17,
    "lat": -37.8423064,
    "lng": 144.88356223970217
  },
  {
    "name": "Newtown",
    "value": 17,
    "lat": -38.1539124,
    "lng": 144.3350959
  },
  {
    "name": "Niddrie",
    "value": 3,
    "lat": -37.7397699,
    "lng": 144.8847881
  },
  {
    "name": "Noble Park",
    "value": 32,
    "lat": -37.966459650000004,
    "lng": 145.176114726163
  },
  {
    "name": "Noble Park North",
    "value": 12,
    "lat": -37.9512702,
    "lng": 145.1908377
  },
  {
    "name": "Norlane",
    "value": 10,
    "lat": -38.0918861,
    "lng": 144.3536879
  },
  {
    "name": "North Geelong",
    "value": 13,
    "lat": -38.12239135,
    "lng": 144.3522479849335
  },
  {
    "name": "North Melbourne",
    "value": 18,
    "lat": -37.8076092,
    "lng": 144.9423514
  },
  {
    "name": "North Shore",
    "value": 2,
    "lat": -38.0950858,
    "lng": 144.3733109
  },
  {
    "name": "Northcote",
    "value": 30,
    "lat": -37.7728157,
    "lng": 145.0009469
  },
  {
    "name": "Notting Hill",
    "value": 8,
    "lat": -37.905582,
    "lng": 145.1455616
  },
  {
    "name": "Nunawading",
    "value": 23,
    "lat": -37.82050305,
    "lng": 145.1751332415871
  },
  {
    "name": "Nyora",
    "value": 1,
    "lat": -38.3062515,
    "lng": 145.6821004
  },
  {
    "name": "OAKLEIGH EAST",
    "value": 9,
    "lat": -37.8996435,
    "lng": 145.10567
  },
  {
    "name": "OFFICER SOUTH",
    "value": 17,
    "lat": -38.0978456,
    "lng": 145.4218003
  },
  {
    "name": "Oak Park",
    "value": 3,
    "lat": -37.7180181,
    "lng": 144.9215041
  },
  {
    "name": "Oaklands Junction",
    "value": 3,
    "lat": -37.5781063,
    "lng": 144.8387784
  },
  {
    "name": "Oakleigh",
    "value": 15,
    "lat": -37.900392,
    "lng": 145.0883324
  },
  {
    "name": "Oakleigh South",
    "value": 17,
    "lat": -37.92321775,
    "lng": 145.09072898845199
  },
  {
    "name": "Ocean Grove",
    "value": 10,
    "lat": -38.267045,
    "lng": 144.52487
  },
  {
    "name": "Officer",
    "value": 215,
    "lat": -38.0662897,
    "lng": 145.41169625320452
  },
  {
    "name": "Olinda",
    "value": 1,
    "lat": -37.8559054,
    "lng": 145.3649682
  },
  {
    "name": "Ormond",
    "value": 6,
    "lat": -37.9034396,
    "lng": 145.03959909925993
  },
  {
    "name": "POINT HENRY",
    "value": 1,
    "lat": -38.1256046,
    "lng": 144.425765
  },
  {
    "name": "Paaratte",
    "value": 1,
    "lat": -38.555442,
    "lng": 142.9616792
  },
  {
    "name": "Pakenham",
    "value": 132,
    "lat": -38.0806283,
    "lng": 145.4863217
  },
  {
    "name": "Pakenham South",
    "value": 1,
    "lat": -38.1389521,
    "lng": 145.5003291
  },
  {
    "name": "Pakenham Upper",
    "value": 1,
    "lat": -38.0090108,
    "lng": 145.5043271
  },
  {
    "name": "Park Orchards",
    "value": 3,
    "lat": -37.7778362,
    "lng": 145.2140351
  },
  {
    "name": "Parkdale",
    "value": 28,
    "lat": -37.9924751,
    "lng": 145.0755901
  },
  {
    "name": "Parkville",
    "value": 53,
    "lat": -37.7871148,
    "lng": 144.9515533
  },
  {
    "name": "Parwan",
    "value": 2,
    "lat": -37.7367835,
    "lng": 144.4678112
  },
  {
    "name": "Pascoe Vale",
    "value": 13,
    "lat": -37.7308567,
    "lng": 144.928195
  },
  {
    "name": "Pascoe Vale South",
    "value": 7,
    "lat": -37.7434265,
    "lng": 144.9384767
  },
  {
    "name": "Patterson Lakes",
    "value": 8,
    "lat": -38.0694493,
    "lng": 145.1432329
  },
  {
    "name": "Pearcedale",
    "value": 1,
    "lat": -38.2015815,
    "lng": 145.242198
  },
  {
    "name": "Phillip Island",
    "value": 4,
    "lat": -38.50717805,
    "lng": 145.18881031587003
  },
  {
    "name": "Pine Lodge",
    "value": 1,
    "lat": -36.362837999999996,
    "lng": 145.54678711018545
  },
  {
    "name": "Pines Forest",
    "value": 1,
    "lat": -36.13115331028147,
    "lng": 147.67913375177616
  },
  {
    "name": "Plenty",
    "value": 3,
    "lat": -37.6136184,
    "lng": 145.1095753
  },
  {
    "name": "Plumpton",
    "value": 37,
    "lat": -37.6727808,
    "lng": 144.6993618
  },
  {
    "name": "Plumpton VIC",
    "value": 1,
    "lat": -37.6727808,
    "lng": 144.6993618
  },
  {
    "name": "Point Cook",
    "value": 135,
    "lat": -37.9064862,
    "lng": 144.7533059
  },
  {
    "name": "Point Lonsdale",
    "value": 4,
    "lat": -38.2725073,
    "lng": 144.6136725
  },
  {
    "name": "Port Arlington",
    "value": 9,
    "lat": -38.12321075,
    "lng": 144.6494048843135
  },
  {
    "name": "Port Melbourne",
    "value": 93,
    "lat": -37.8333613,
    "lng": 144.9219203
  },
  {
    "name": "Port Melbourne.",
    "value": 5,
    "lat": -37.8333613,
    "lng": 144.9219203
  },
  {
    "name": "Portsea",
    "value": 5,
    "lat": -38.3228212,
    "lng": 144.7004208
  },
  {
    "name": "Powelltown",
    "value": 1,
    "lat": -37.8630657,
    "lng": 145.7514607
  },
  {
    "name": "Prahran",
    "value": 18,
    "lat": -37.849953,
    "lng": 144.98981649178617
  },
  {
    "name": "Preston",
    "value": 50,
    "lat": -37.7395301,
    "lng": 145.0004919
  },
  {
    "name": "Preston West",
    "value": 2,
    "lat": -38.140190763075445,
    "lng": 144.3510256638608
  },
  {
    "name": "Princes Hill",
    "value": 5,
    "lat": -37.78317785,
    "lng": 144.96493807656168
  },
  {
    "name": "Promenade SKYE",
    "value": 1,
    "lat": -38.0915275,
    "lng": 145.2044714
  },
  {
    "name": "Puckapunyal",
    "value": 1,
    "lat": -37.0008314,
    "lng": 145.0359724
  },
  {
    "name": "Pyalong",
    "value": 2,
    "lat": -37.110468,
    "lng": 144.8505740447336
  },
  {
    "name": "Queenscliff",
    "value": 1,
    "lat": -38.2671132,
    "lng": 144.6612949
  },
  {
    "name": "RAVENHALL",
    "value": 16,
    "lat": -37.7754956,
    "lng": 144.7366326
  },
  {
    "name": "Red Hill",
    "value": 1,
    "lat": -38.3683762,
    "lng": 145.0209335
  },
  {
    "name": "Reefton",
    "value": 1,
    "lat": -37.6699217,
    "lng": 145.902273443318
  },
  {
    "name": "Research",
    "value": 2,
    "lat": -37.7066557,
    "lng": 145.189067
  },
  {
    "name": "Reservior",
    "value": 1,
    "lat": -31.07946785,
    "lng": 150.94233046111628
  },
  {
    "name": "Reservoir",
    "value": 39,
    "lat": -37.7168415,
    "lng": 145.0069944
  },
  {
    "name": "Richmond",
    "value": 52,
    "lat": -37.820386,
    "lng": 145.0025144
  },
  {
    "name": "Riddells Creek",
    "value": 2,
    "lat": -37.4649363,
    "lng": 144.6799996
  },
  {
    "name": "Ringwood",
    "value": 31,
    "lat": -37.8158726,
    "lng": 145.22911125106023
  },
  {
    "name": "Ringwood East",
    "value": 19,
    "lat": -37.8117518,
    "lng": 145.2499467
  },
  {
    "name": "Ringwood North",
    "value": 5,
    "lat": -37.7950927,
    "lng": 145.2331186
  },
  {
    "name": "Rockbank",
    "value": 40,
    "lat": -37.7312767,
    "lng": 144.6607316
  },
  {
    "name": "Rokewood",
    "value": 2,
    "lat": -37.9015846,
    "lng": 143.7198039
  },
  {
    "name": "Romsey",
    "value": 2,
    "lat": -37.3518801,
    "lng": 144.7374475
  },
  {
    "name": "Rosanna",
    "value": 11,
    "lat": -37.7428788,
    "lng": 145.0661791
  },
  {
    "name": "Rosebud",
    "value": 15,
    "lat": -38.3710325,
    "lng": 144.9095115
  },
  {
    "name": "Rowevile",
    "value": 2,
    "lat": -36.5986096,
    "lng": 144.6780052
  },
  {
    "name": "Rowsley",
    "value": 1,
    "lat": -37.7190005,
    "lng": 144.36780000066472
  },
  {
    "name": "Rowville",
    "value": 57,
    "lat": -37.9239267,
    "lng": 145.2447672
  },
  {
    "name": "Roxburgh Park",
    "value": 17,
    "lat": -37.63815625,
    "lng": 144.93533017828446
  },
  {
    "name": "Rye",
    "value": 10,
    "lat": -38.3821684,
    "lng": 144.8099264
  },
  {
    "name": "SUNBURY VIC",
    "value": 1,
    "lat": -37.5791363,
    "lng": 144.7279832
  },
  {
    "name": "Safety Beach",
    "value": 11,
    "lat": -38.3153642,
    "lng": 145.000282
  },
  {
    "name": "Sale",
    "value": 1,
    "lat": -38.1094463,
    "lng": 147.0656717
  },
  {
    "name": "San Remo",
    "value": 2,
    "lat": -38.5214924,
    "lng": 145.369394
  },
  {
    "name": "Sanctuary Lakes",
    "value": 1,
    "lat": -37.8994089,
    "lng": 144.7649145
  },
  {
    "name": "Sancturary Lakes",
    "value": 1,
    "lat": -38.1879659,
    "lng": 144.4553698
  },
  {
    "name": "Sandringham",
    "value": 20,
    "lat": -37.9502592,
    "lng": 145.0043868
  },
  {
    "name": "Sandy Point",
    "value": 1,
    "lat": -38.818836,
    "lng": 146.121562
  },
  {
    "name": "Sassafras",
    "value": 2,
    "lat": -37.8628502,
    "lng": 145.3536965
  },
  {
    "name": "Scoresby",
    "value": 28,
    "lat": -37.9025786,
    "lng": 145.2183066
  },
  {
    "name": "Seabrook",
    "value": 3,
    "lat": -37.8806797,
    "lng": 144.7578334
  },
  {
    "name": "Seaford",
    "value": 58,
    "lat": -38.1040134,
    "lng": 145.1282259
  },
  {
    "name": "Seaholme",
    "value": 4,
    "lat": -37.86782395,
    "lng": 144.84110845327947
  },
  {
    "name": "Sebastopol",
    "value": 6,
    "lat": -37.588417250000006,
    "lng": 143.83464848170172
  },
  {
    "name": "Seddon",
    "value": 5,
    "lat": -37.80897775,
    "lng": 144.89567019256515
  },
  {
    "name": "Selby",
    "value": 2,
    "lat": -37.9187608,
    "lng": 145.3784097
  },
  {
    "name": "Seville",
    "value": 1,
    "lat": -37.7782042,
    "lng": 145.4594001
  },
  {
    "name": "Seymour",
    "value": 4,
    "lat": -37.0241543,
    "lng": 145.1362432
  },
  {
    "name": "Shepherd Flat",
    "value": 1,
    "lat": -37.2739545,
    "lng": 144.1018998
  },
  {
    "name": "Shepparton",
    "value": 2,
    "lat": -36.3831633,
    "lng": 145.3988874
  },
  {
    "name": "Shoreham",
    "value": 1,
    "lat": -38.4247467,
    "lng": 145.0554939
  },
  {
    "name": "Skye",
    "value": 25,
    "lat": -38.1051265,
    "lng": 145.2162331
  },
  {
    "name": "Smythes Creek",
    "value": 6,
    "lat": -37.6028625,
    "lng": 143.76716295482177
  },
  {
    "name": "Soldiers Hill",
    "value": 2,
    "lat": -37.55174465,
    "lng": 143.85937523478583
  },
  {
    "name": "Somers",
    "value": 4,
    "lat": -38.3923474,
    "lng": 145.1726499
  },
  {
    "name": "Somerton",
    "value": 17,
    "lat": -37.634688,
    "lng": 144.9507961
  },
  {
    "name": "Somerville",
    "value": 11,
    "lat": -38.22542,
    "lng": 145.1763347
  },
  {
    "name": "Sorrento",
    "value": 8,
    "lat": -38.3447273,
    "lng": 144.7420938
  },
  {
    "name": "South Elliminyt",
    "value": 1,
    "lat": -38.39380137482935,
    "lng": 143.5965730025031
  },
  {
    "name": "South Geelong",
    "value": 4,
    "lat": -38.1586761,
    "lng": 144.3593889
  },
  {
    "name": "South Kingsville",
    "value": 3,
    "lat": -37.8306664,
    "lng": 144.8713429
  },
  {
    "name": "South Melbourne",
    "value": 26,
    "lat": -37.822925549999994,
    "lng": 144.96865622637097
  },
  {
    "name": "South Morang",
    "value": 67,
    "lat": -37.64924405,
    "lng": 145.0672450098665
  },
  {
    "name": "South Wharf",
    "value": 12,
    "lat": -37.8253279,
    "lng": 144.9493432
  },
  {
    "name": "South Yarra",
    "value": 55,
    "lat": -37.8377695,
    "lng": 144.9918537
  },
  {
    "name": "Southbank",
    "value": 33,
    "lat": -37.8253618,
    "lng": 144.9640203
  },
  {
    "name": "Spotswood",
    "value": 17,
    "lat": -37.8307391,
    "lng": 144.885881524938
  },
  {
    "name": "Springvale",
    "value": 53,
    "lat": -37.9496947,
    "lng": 145.1539118
  },
  {
    "name": "Springvale South",
    "value": 6,
    "lat": -37.9708611,
    "lng": 145.1478692
  },
  {
    "name": "St Albans",
    "value": 37,
    "lat": -37.74455605,
    "lng": 144.79968642559174
  },
  {
    "name": "St Albans Park",
    "value": 1,
    "lat": -38.1939926,
    "lng": 144.3907557
  },
  {
    "name": "St Helena",
    "value": 3,
    "lat": -37.687916099999995,
    "lng": 145.13939412744122
  },
  {
    "name": "St Kilda",
    "value": 59,
    "lat": -37.8638261,
    "lng": 144.981637
  },
  {
    "name": "St Kilda East",
    "value": 3,
    "lat": -37.8668218,
    "lng": 145.0021657
  },
  {
    "name": "St Kilda West",
    "value": 3,
    "lat": -37.8579958,
    "lng": 144.9712452
  },
  {
    "name": "St Leonards",
    "value": 9,
    "lat": -38.1707592,
    "lng": 144.7182761
  },
  {
    "name": "St.Albans",
    "value": 1,
    "lat": -37.74455605,
    "lng": 144.79968642559174
  },
  {
    "name": "St.Helena",
    "value": 2,
    "lat": -37.687916099999995,
    "lng": 145.13939412744122
  },
  {
    "name": "St.Kilda",
    "value": 1,
    "lat": -37.8638261,
    "lng": 144.981637
  },
  {
    "name": "Staughton Vale",
    "value": 2,
    "lat": -37.847064,
    "lng": 144.25770041408913
  },
  {
    "name": "Stawell",
    "value": 1,
    "lat": -37.0586869,
    "lng": 142.7745476
  },
  {
    "name": "Stonehaven",
    "value": 1,
    "lat": -38.122703,
    "lng": 144.2239614
  },
  {
    "name": "Strathdale",
    "value": 1,
    "lat": -36.768244,
    "lng": 144.31860035676533
  },
  {
    "name": "Strathmore",
    "value": 18,
    "lat": -37.7333202,
    "lng": 144.9182433
  },
  {
    "name": "Strathmore Heights",
    "value": 2,
    "lat": -37.7133663,
    "lng": 144.8969057
  },
  {
    "name": "Strathtulloh",
    "value": 30,
    "lat": -37.7324394,
    "lng": 144.5975017
  },
  {
    "name": "Summerlands",
    "value": 1,
    "lat": -38.507399,
    "lng": 145.1452071
  },
  {
    "name": "Sunbury",
    "value": 197,
    "lat": -37.5791363,
    "lng": 144.7279832
  },
  {
    "name": "Sunshine",
    "value": 23,
    "lat": -37.7887617,
    "lng": 144.8331303
  },
  {
    "name": "Sunshine North",
    "value": 20,
    "lat": -37.7639467,
    "lng": 144.8361969
  },
  {
    "name": "Sunshine West",
    "value": 26,
    "lat": -37.7854449,
    "lng": 144.7903402396812
  },
  {
    "name": "Surrey Hills",
    "value": 23,
    "lat": -37.8271881,
    "lng": 145.0978326
  },
  {
    "name": "Swan Hill",
    "value": 1,
    "lat": -35.3390784,
    "lng": 143.5588436
  },
  {
    "name": "Sydenham",
    "value": 11,
    "lat": -37.6997223,
    "lng": 144.7653295
  },
  {
    "name": "TARWIN",
    "value": 1,
    "lat": -38.7732865,
    "lng": 145.9167184
  },
  {
    "name": "TAYLOR RISE",
    "value": 1,
    "lat": -37.2274879,
    "lng": 145.8799462
  },
  {
    "name": "THORNHILL PARK",
    "value": 27,
    "lat": -37.7274099,
    "lng": 144.6259215
  },
  {
    "name": "Tallarook",
    "value": 3,
    "lat": -37.0923707,
    "lng": 145.1028205
  },
  {
    "name": "Tarmeit",
    "value": 1,
    "lat": -36.5986096,
    "lng": 144.6780052
  },
  {
    "name": "Tarneit",
    "value": 521,
    "lat": -37.8321522,
    "lng": 144.69462
  },
  {
    "name": "Tarniet",
    "value": 3,
    "lat": -36.5986096,
    "lng": 144.6780052
  },
  {
    "name": "Taylors Hill",
    "value": 6,
    "lat": -37.7152241,
    "lng": 144.7533127
  },
  {
    "name": "Taylors Lakes",
    "value": 20,
    "lat": -37.698633,
    "lng": 144.7863077
  },
  {
    "name": "Teesdale",
    "value": 4,
    "lat": -38.0287529,
    "lng": 144.0475898
  },
  {
    "name": "Templestowe",
    "value": 21,
    "lat": -37.7540588,
    "lng": 145.1486152
  },
  {
    "name": "Templestowe Lower",
    "value": 10,
    "lat": -37.7638749,
    "lng": 145.1122762
  },
  {
    "name": "Tennis Aust - Melbourne",
    "value": 15,
    "lat": -37.8204011,
    "lng": 144.9799235
  },
  {
    "name": "Tennis Australia - Melbourne",
    "value": 6,
    "lat": -37.8204011,
    "lng": 144.9799235
  },
  {
    "name": "Thomastown",
    "value": 35,
    "lat": -37.6832672,
    "lng": 145.0081104
  },
  {
    "name": "Thomson",
    "value": 1,
    "lat": -38.1698547,
    "lng": 144.3789317
  },
  {
    "name": "Thornbury",
    "value": 15,
    "lat": -37.7549944,
    "lng": 144.9985944
  },
  {
    "name": "Thornton",
    "value": 1,
    "lat": -37.272738,
    "lng": 145.8154196
  },
  {
    "name": "Tidal River",
    "value": 2,
    "lat": -39.0302707,
    "lng": 146.3218352
  },
  {
    "name": "Timboon West",
    "value": 1,
    "lat": -38.53889,
    "lng": 142.922725
  },
  {
    "name": "Toolern Vale",
    "value": 7,
    "lat": -37.6074215,
    "lng": 144.5941995
  },
  {
    "name": "Tooradin",
    "value": 2,
    "lat": -38.2138303,
    "lng": 145.3816827
  },
  {
    "name": "Toorak",
    "value": 28,
    "lat": -37.850751,
    "lng": 145.013698902256
  },
  {
    "name": "Tootgarook",
    "value": 4,
    "lat": -38.3777277,
    "lng": 144.8502239
  },
  {
    "name": "Torquay",
    "value": 38,
    "lat": -38.3266551,
    "lng": 144.3134076
  },
  {
    "name": "Tottenham",
    "value": 8,
    "lat": -37.79926395,
    "lng": 144.86320673095977
  },
  {
    "name": "Traralgon",
    "value": 4,
    "lat": -38.1946636,
    "lng": 146.5381646
  },
  {
    "name": "Traralgon North",
    "value": 1,
    "lat": -38.173781399999996,
    "lng": 146.55112866079332
  },
  {
    "name": "Traralgon South",
    "value": 2,
    "lat": -38.286013499999996,
    "lng": 146.5542524903624
  },
  {
    "name": "Travancore",
    "value": 1,
    "lat": -37.7807553,
    "lng": 144.935503
  },
  {
    "name": "Trentham",
    "value": 1,
    "lat": -37.3900875,
    "lng": 144.3263388
  },
  {
    "name": "Trida",
    "value": 1,
    "lat": -38.319964,
    "lng": 145.97189982938187
  },
  {
    "name": "Truagnina",
    "value": 1,
    "lat": -36.5986096,
    "lng": 144.6780052
  },
  {
    "name": "Truganina",
    "value": 386,
    "lat": -37.8089015,
    "lng": 144.721139
  },
  {
    "name": "Tuerong",
    "value": 4,
    "lat": -38.2971005,
    "lng": 145.09608
  },
  {
    "name": "Tullamarine",
    "value": 38,
    "lat": -37.704658,
    "lng": 144.8717732
  },
  {
    "name": "Tyabb",
    "value": 2,
    "lat": -38.269149299999995,
    "lng": 145.1798111468653
  },
  {
    "name": "University of Melbourne",
    "value": 1,
    "lat": -37.7969983,
    "lng": 144.954471
  },
  {
    "name": "Upper Ferntree Gully",
    "value": 3,
    "lat": -37.8926144,
    "lng": 145.3077074
  },
  {
    "name": "Upwey",
    "value": 9,
    "lat": -37.9036086,
    "lng": 145.3313506
  },
  {
    "name": "Various Locations",
    "value": 2,
    "lat": -37.6555038,
    "lng": 145.07867044708325
  },
  {
    "name": "Ventnor",
    "value": 60,
    "lat": -38.4690103,
    "lng": 145.1715254
  },
  {
    "name": "Vermont",
    "value": 27,
    "lat": -37.843892100000005,
    "lng": 145.20088124290012
  },
  {
    "name": "Vermont South",
    "value": 18,
    "lat": -37.854386,
    "lng": 145.1878065
  },
  {
    "name": "Vic",
    "value": 1,
    "lat": -36.5986096,
    "lng": 144.6780052
  },
  {
    "name": "Viewbank",
    "value": 5,
    "lat": -37.7399103,
    "lng": 145.0932329
  },
  {
    "name": "WALLAN",
    "value": 53,
    "lat": -37.4138855,
    "lng": 144.9774549
  },
  {
    "name": "WARRAGUL",
    "value": 33,
    "lat": -38.1588674,
    "lng": 145.933629
  },
  {
    "name": "WEIR VIEWS",
    "value": 34,
    "lat": -37.7323715,
    "lng": 144.5708942
  },
  {
    "name": "WINTER VALLEY",
    "value": 2,
    "lat": -37.5694103,
    "lng": 143.7847597
  },
  {
    "name": "Wallinduc",
    "value": 2,
    "lat": -37.8726535,
    "lng": 143.5244959256545
  },
  {
    "name": "Wallington",
    "value": 4,
    "lat": -38.2243412,
    "lng": 144.5047089
  },
  {
    "name": "Wandana Heights",
    "value": 1,
    "lat": -38.1776503,
    "lng": 144.2996684
  },
  {
    "name": "Wandin North",
    "value": 2,
    "lat": -37.7806025,
    "lng": 145.4262934
  },
  {
    "name": "Wandong",
    "value": 7,
    "lat": -37.3545847,
    "lng": 145.0264987
  },
  {
    "name": "Wantirna",
    "value": 27,
    "lat": -37.85591645,
    "lng": 145.23018292594725
  },
  {
    "name": "Wantirna South",
    "value": 39,
    "lat": -37.8737902,
    "lng": 145.2217475
  },
  {
    "name": "Waratah Bay",
    "value": 1,
    "lat": -38.798411,
    "lng": 146.05984824134015
  },
  {
    "name": "Warburton",
    "value": 3,
    "lat": -37.7536223,
    "lng": 145.6887265
  },
  {
    "name": "Warneet",
    "value": 2,
    "lat": -38.2213749,
    "lng": 145.3117316
  },
  {
    "name": "Warrandyte",
    "value": 1,
    "lat": -37.7465024,
    "lng": 145.185107
  },
  {
    "name": "Warranwood",
    "value": 4,
    "lat": -37.7730016,
    "lng": 145.2505908
  },
  {
    "name": "Warrenheip",
    "value": 1,
    "lat": -37.5765814,
    "lng": 143.9582352
  },
  {
    "name": "Warrnambool",
    "value": 4,
    "lat": -38.3826242,
    "lng": 142.4814199
  },
  {
    "name": "Waterways",
    "value": 3,
    "lat": -38.0147783,
    "lng": 145.1305166
  },
  {
    "name": "Watsonia",
    "value": 24,
    "lat": -37.7109468,
    "lng": 145.0837808
  },
  {
    "name": "Watsonia North",
    "value": 2,
    "lat": -37.696046,
    "lng": 145.084977
  },
  {
    "name": "Waurn Ponds",
    "value": 22,
    "lat": -38.2158244,
    "lng": 144.3061193
  },
  {
    "name": "Wedderburn",
    "value": 1,
    "lat": -36.4192187,
    "lng": 143.6143424
  },
  {
    "name": "Wendouree",
    "value": 5,
    "lat": -37.5501895,
    "lng": 143.83503056464738
  },
  {
    "name": "Werneth",
    "value": 1,
    "lat": -37.9369765,
    "lng": 143.6013411238617
  },
  {
    "name": "Werribee",
    "value": 204,
    "lat": -37.8995007,
    "lng": 144.6609036
  },
  {
    "name": "Werribee South",
    "value": 22,
    "lat": -37.92754325,
    "lng": 144.6712824060007
  },
  {
    "name": "Wesburn",
    "value": 1,
    "lat": -37.7661584,
    "lng": 145.646268
  },
  {
    "name": "West Bendigo",
    "value": 1,
    "lat": -36.751543,
    "lng": 144.245612117233
  },
  {
    "name": "West Brunswick",
    "value": 1,
    "lat": -37.7633334,
    "lng": 144.9425563
  },
  {
    "name": "West Footscray",
    "value": 23,
    "lat": -37.80174125,
    "lng": 144.8840743363326
  },
  {
    "name": "West Meadows",
    "value": 2,
    "lat": -36.552364140798666,
    "lng": 145.99398173492247
  },
  {
    "name": "West Melbourne",
    "value": 45,
    "lat": -37.808747,
    "lng": 144.9238207
  },
  {
    "name": "West Melton",
    "value": 1,
    "lat": -37.68060965,
    "lng": 144.56716396518243
  },
  {
    "name": "Wheelers Hill",
    "value": 41,
    "lat": -37.901550650000004,
    "lng": 145.19655434714866
  },
  {
    "name": "White Hills",
    "value": 1,
    "lat": -36.7275425,
    "lng": 144.30282669604821
  },
  {
    "name": "Whittington",
    "value": 1,
    "lat": -38.1771013,
    "lng": 144.3920658
  },
  {
    "name": "Whittlesea",
    "value": 9,
    "lat": -37.5507305,
    "lng": 145.0618809755639
  },
  {
    "name": "Wildwood",
    "value": 4,
    "lat": -37.5647385,
    "lng": 144.8007525
  },
  {
    "name": "Williams Landing",
    "value": 6,
    "lat": -37.87002995,
    "lng": 144.74693040256068
  },
  {
    "name": "Williamstown",
    "value": 26,
    "lat": -37.8611788,
    "lng": 144.8898569
  },
  {
    "name": "Williamstown North",
    "value": 15,
    "lat": -37.85709755,
    "lng": 144.88894589587125
  },
  {
    "name": "Winchelsea",
    "value": 3,
    "lat": -38.2419077,
    "lng": 143.9859604
  },
  {
    "name": "Winchelsea South",
    "value": 1,
    "lat": -38.3182037,
    "lng": 143.9708366
  },
  {
    "name": "Windsor",
    "value": 6,
    "lat": -37.85582435,
    "lng": 144.9916848077674
  },
  {
    "name": "Wodonga",
    "value": 2,
    "lat": -36.1205539,
    "lng": 146.8880837
  },
  {
    "name": "Wollert",
    "value": 349,
    "lat": -37.5939889,
    "lng": 145.0337333
  },
  {
    "name": "Wonga Park",
    "value": 3,
    "lat": -37.7390001,
    "lng": 145.2669658
  },
  {
    "name": "Wonthaggi",
    "value": 2,
    "lat": -38.6043664,
    "lng": 145.5913433
  },
  {
    "name": "Woodend",
    "value": 1,
    "lat": -37.3536857,
    "lng": 144.5341381
  },
  {
    "name": "Woodend North",
    "value": 2,
    "lat": -37.3234495,
    "lng": 144.5263769714403
  },
  {
    "name": "Woodstock",
    "value": 28,
    "lat": -37.546034,
    "lng": 145.056289
  },
  {
    "name": "Woori Yallock",
    "value": 1,
    "lat": -37.7793329,
    "lng": 145.5301262
  },
  {
    "name": "Wye River",
    "value": 1,
    "lat": -38.6333083,
    "lng": 143.8896997
  },
  {
    "name": "Wyndham Vale",
    "value": 120,
    "lat": -37.8722432,
    "lng": 144.6084185
  },
  {
    "name": "Yallambie",
    "value": 7,
    "lat": -37.7251655,
    "lng": 145.0935218
  },
  {
    "name": "Yan Yean",
    "value": 3,
    "lat": -37.553778449999996,
    "lng": 145.1406937322213
  },
  {
    "name": "Yarra Glen",
    "value": 7,
    "lat": -37.6573475,
    "lng": 145.3743964
  },
  {
    "name": "Yarra Junction",
    "value": 2,
    "lat": -37.7821693,
    "lng": 145.6150255
  },
  {
    "name": "Yarra Park",
    "value": 2,
    "lat": -37.61003685,
    "lng": 145.58810699963294
  },
  {
    "name": "Yarrambat",
    "value": 5,
    "lat": -37.6375473,
    "lng": 145.1349293
  },
  {
    "name": "Yarraville",
    "value": 47,
    "lat": -37.81574515,
    "lng": 144.88996772207105
  },
  {
    "name": "Yea",
    "value": 1,
    "lat": -37.3589308,
    "lng": 145.4708183
  },
  {
    "name": "Yuroke",
    "value": 3,
    "lat": -37.5894631,
    "lng": 144.8789803
  }
];
